<template>
  <input-widget
    :model="model"
    :attribute="attribute"
    type="select2"
    :items="items"
    :title-hint="titleHint"
    :hint="hint"
    :disabled="disabled"
    :options="options"
    :label="label"
    :multiple="multiple"
    value-field="key" display-field="${item.value}"
    @select2Select="select2Select">
  </input-widget>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import BaseModel from "@/core/components/input-widget/BaseModel";
import InputWidget from "@/core/components/input-widget/InputWidget.vue";
import i18n from "@/shared/i18n";

const {mapState} = createNamespacedHelpers('global');
const LIFECYCLE_NA_FILTER_VALUE = 'n/a';

export default {
  name: "CataloguingLifecycleSelectInputWidget",
  components: {InputWidget},
  props: {
    model: {
      type: BaseModel,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    titleHint: {
      type: [Boolean, String],
      default: false
    },
    hint: {
      type: [Boolean, String],
      default: false
    },
    label: {
      type: [Boolean, String],
      default: null
    },
    multiple: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      cataloguingLifecycleOptions: state => state.cataloguingLifecycleOptions,
    }),
    items() {
      const options = this.cataloguingLifecycleOptions || [];
      if (!this.multiple) {
        return options;
      }
      return [...options, {key: LIFECYCLE_NA_FILTER_VALUE, value: i18n.t('N/A')}];
    }
  },
  methods: {
    select2Select(data) {
      this.$emit('select2Select', data);
    }
  }
}
</script>
<style scoped lang="scss">

</style>
